import { GetCurrentWindowSize } from "../hooks/useWindowSize";

export function sortBySessionsQuranProgress(
  arr: { [key: string]: number }[]
): { [key: string]: number }[] {
  function compare(
    a: { [key: string]: number },
    b: { [key: string]: number }
  ): number {
    const keyA: number = parseInt(Object.keys(a)[0]);
    const keyB: number = parseInt(Object.keys(b)[0]);
    const progressA: number = Object.values(a)[0] ?? 0;
    const progressB: number = Object.values(b)[0] ?? 0;
    if (progressA === null && progressB !== null) return 1;
    if (progressB === null && progressA !== null) return -1;
    if (progressA === progressB) {
      return keyA - keyB;
    }
    return progressA! - progressB!;
  }

  return arr.sort(compare);
}

export function replaceQuranProgressNullWithZero(
  arr: { [key: string]: number | null }[]
): { [key: string]: number }[] {
  const newArr: { [key: string]: number }[] = [];
  arr.forEach((obj) => {
    const newObj: { [key: string]: number } = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = obj[key] === null ? 0 : obj[key]!;
      }
    }
    newArr.push(newObj);
  });
  return newArr;
}

export function sortAndCleanQuranProgress(
  arr: { [key: string]: number | null }[],
  renderItems: number
): { [key: string]: number }[] {
  const nonNullableQuranProgress = replaceQuranProgressNullWithZero(arr);
  const sortedBySessionsQuranProgress: { [key: string]: number }[] =
    sortBySessionsQuranProgress(nonNullableQuranProgress);
  const renderNumber =
    sortedBySessionsQuranProgress.length < 11
      ? -sortedBySessionsQuranProgress.length
      : -renderItems;

  const lastTenQuranProgress: { [key: string]: number }[] =
    sortedBySessionsQuranProgress.slice(renderNumber);

  return lastTenQuranProgress;
}
